import { useContext } from "react";
// import SubscribeContext from "../context/subscribe/SubscribeContext";
import AuthContext from "../context/auth/AuthContext";
import AlertContext from "../context/alert/AlertContext";
import CartContext from "../context/cart/CartContext";
import useAlert from "./set-alert";
import {
  UPDATE_SUBSCRIPTION,
  ADD_SUBSCRIPTION,
  ADD_RS_SUBSCRIPTION,
  CANCEL_SUBSCRIPTION,
  UPDATE_PAYMENT,
  GET_PAYMENT,
  DELETE_CART_ITEM,
} from "../context/types";
import ConfigContext from "../context/config/ConfigContext";

const useEntityContext = () => {
  const alertContext = useContext(AlertContext);
  const authContext = useContext(AuthContext);
  const cartContext = useContext(CartContext);
  const configContext = useContext(ConfigContext);

  const { getConfigValueByCode } = configContext;
  const {
    loading,
    addSubscription,
    addRSSubscription,
    updateSubscription,
    cancelSubscription,
    updatePayment,
    getPaymentMethod,
    deleteItem,
  } = cartContext;
  const { setAlert, clearAlerts } = alertContext;
  const { token } = authContext;
  //   const subscribeContext = useContext(SubscribeContext);
  const [updateAlert] = useAlert();
  //   const [status, setStatus] = useState(loading);

  const postAddSubscription = async (formData) => {
    return new Promise(async (resolve, reject) => {
      try {
        console.log("Submitting Request");
        console.log("LOADING BEfore>>>>>", loading);
        const res = await addSubscription(formData, token);
        console.log("LOADING After>>>>>", loading);
        console.log("Completing Request", res);
        const resStatus = updateAlert(res.data);
        //   setStatus();
        console.log("Completing Request");
        resolve(resStatus);
      } catch (err) {
        console.log("$$$$Error", JSON.stringify(err));
        clearAlerts();
        const msg = getConfigValueByCode("patronConfig", "RESPONSE_MSG", 475);
        setAlert(msg, "danger"); //   setStatus(false);
        resolve(false);
      }
    });
  };

  const postAddRSSubscription = async (formData) => {
    return new Promise(async (resolve, reject) => {
      try {
        console.log("Submitting Request");
        console.log("LOADING BEfore>>>>>", loading);
        const res = await addRSSubscription(formData, token);
        console.log("LOADING After>>>>>", loading);
        console.log("Completing Request", res);
        const resStatus = updateAlert(res.data);
        //   setStatus();
        console.log("Completing Request");
        resolve(resStatus);
      } catch (err) {
        console.log("$$$$Error", JSON.stringify(err));
        clearAlerts();
        const msg = getConfigValueByCode("patronConfig", "RESPONSE_MSG", 475);
        setAlert(msg, "warning");
        //   setStatus(false);
        resolve(false);
      }
    });
  };

  const postModifySubscription = async (formData) => {
    return new Promise(async (resolve, reject) => {
      try {
        console.log("Submitting Request");
        console.log("LOADING BEfore>>>>>", loading);
        const res = await updateSubscription(formData, token);
        console.log("LOADING After>>>>>", loading);
        console.log("Completing Request", res);
        const resStatus = updateAlert(res.data);
        //   setStatus();
        console.log("Completing Request");
        resolve(resStatus);
      } catch (err) {
        console.log("$$$$Error", JSON.stringify(err));
        clearAlerts();
        const msg = getConfigValueByCode("patronConfig", "RESPONSE_MSG", 475);
        setAlert(msg, "warning"); //   setStatus(false);
        resolve(false);
      }
    });
  };
  const postCancelSubscription = async (formData) => {
    return new Promise(async (resolve, reject) => {
      try {
        console.log("Submitting Request");
        console.log("LOADING BEfore>>>>>", loading);
        const res = await cancelSubscription(formData, token);
        console.log("LOADING After>>>>>", loading);
        console.log("Completing Request", res);
        const resStatus = updateAlert(res.data);
        //   setStatus();
        console.log("Completing Request");
        resolve(resStatus);
      } catch (err) {
        console.log("$$$$Error", JSON.stringify(err));
        clearAlerts();
        const msg = getConfigValueByCode("patronConfig", "RESPONSE_MSG", 475);
        setAlert(msg, "warning"); //   setStatus(false);
        resolve(false);
      }
    });
  };

  const postUpdatePayment = async (formData) => {
    return new Promise(async (resolve, reject) => {
      try {
        console.log("Submitting Request");
        console.log("LOADING BEfore>>>>>", loading);
        const res = await updatePayment(formData, token);
        console.log("LOADING After>>>>>", loading);
        console.log("Completing Request", res);
        const resStatus = updateAlert(res.data);
        //   setStatus();
        console.log("Completing Request");
        resolve(resStatus);
      } catch (err) {
        console.log("$$$$Error", JSON.stringify(err));
        clearAlerts();
        const msg = getConfigValueByCode("patronConfig", "RESPONSE_MSG", 475);
        setAlert(msg, "warning"); //   setStatus(false);
        resolve(false);
      }
    });
  };

  const getPayment = async (formData) => {
    return new Promise(async (resolve, reject) => {
      try {
        console.log("Submitting Request");
        console.log("LOADING BEfore>>>>>", loading);
        const res = await getPaymentMethod(formData, token);
        console.log("LOADING After>>>>>", loading);
        console.log("Completing Request", res);
        updateAlert(res.data);
        //   setStatus();
        console.log("Completing Request");
        resolve(res.data.data);
      } catch (err) {
        console.log("$$$$Error", JSON.stringify(err));
        clearAlerts();
        const msg = getConfigValueByCode("patronConfig", "RESPONSE_MSG", 475);
        setAlert(msg, "warning"); //   setStatus(false);
        resolve(false);
      }
    });
  };

  const postDeleteCartItem = async (formData) => {
    return new Promise(async (resolve, reject) => {
      try {
        console.log("Submitting Request");
        console.log("LOADING BEfore>>>>>", loading);
        const res = await deleteItem(formData, token);
        console.log("LOADING After>>>>>", loading);
        console.log("Completing Request", res);
        const resStatus = updateAlert(res.data);
        //   setStatus();
        console.log("Completing Request");
        resolve(resStatus);
      } catch (err) {
        console.log("$$$$Error", JSON.stringify(err));
        clearAlerts();
        const msg = getConfigValueByCode("patronConfig", "RESPONSE_MSG", 475);
        setAlert(msg, "warning"); //   setStatus(false);
        resolve(false);
      }
    });
  };
  const actionMethod = (formData, action) => {
    switch (action) {
      case ADD_SUBSCRIPTION:
        return postAddSubscription(formData);
      case ADD_RS_SUBSCRIPTION:
        return postAddRSSubscription(formData);
      case UPDATE_SUBSCRIPTION:
        return postModifySubscription(formData);
      case CANCEL_SUBSCRIPTION:
        return postCancelSubscription(formData);
      case UPDATE_PAYMENT:
        return postUpdatePayment(formData);
      case GET_PAYMENT:
        return getPayment(formData);
      case DELETE_CART_ITEM:
        return postDeleteCartItem(formData);
      default:
        return null;
    }
  };

  return [loading, actionMethod];
};

export default useEntityContext;
